import * as React from 'react';
import { MouseEventHandler } from 'react';
import ComboBox from '../../../components/ComboBox/ComboBox';

type AnalyticsFilterWithComboboxProps = {
    name: string;
    value: string;
    values: Array<any>;
    onChange: MouseEventHandler<HTMLDivElement>;
    onDelete: MouseEventHandler<HTMLDivElement>;
}

export function AnalyticsFilterWithCombobox({ name, value, values, onChange, onDelete }: AnalyticsFilterWithComboboxProps) {
    return <div className="analytics-filter-with-combobox">
        <div
            className="analytics-filter-with-combobox__delete-btn"
            onClick={onDelete}>
            <i className="icon icon-alan-close-rounded" />
        </div>
        <div className="analytics-filter-with-combobox__name">{name}</div>
        <div className="analytics-filter-with-combobox__list">
            <ComboBox
                values={values}
                valueKey="key"
                valueName="label"
                selectedValueId={value}
                renderItem={(item) => {
                    return <div>{item.label}</div>;
                }}
                onValueSelect={onChange}
            />
        </div>
    </div>;
}